import { useEffect, useRef } from 'react'
import '../styles/MapContextMenu.css'

// Node menu for the infrastructure editor: a left-click on a node of the path
// being drawn opens it. The plain click used to fork a branch silently, which
// was undiscoverable and turned every mis-click into a new branch.
//
// Everything here is also reachable from the sidebar; this menu is the shortcut
// for the hand already on the map, never the only way in.
export function InfraNodeMenu({ menu, onClose, infrastructurePath, onConnect, onFork, onDelete }) {
  const ref = useRef(null)

  // Opening the menu moves focus into it, so the keyboard can reach the actions
  // and Escape has something to close. Both are required for a menu that a
  // pointer gesture opened.
  useEffect(() => {
    if (!menu) return undefined
    ref.current?.querySelector('button')?.focus()
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose() } }
    document.addEventListener('keydown', onKey, true)
    return () => document.removeEventListener('keydown', onKey, true)
  }, [menu, onClose])

  if (!menu) return null
  const node = (infrastructurePath || [])[menu.index]
  const count = (infrastructurePath || []).length
  const run = (fn, ...args) => { fn?.(...args); onClose() }

  return (
    <>
      <div
        className="map-context-backdrop"
        onClick={onClose}
        onContextMenu={(e) => { e.preventDefault(); onClose() }}
      />
      <div
        ref={ref}
        className="map-context-menu"
        style={{ left: menu.x, top: menu.y }}
        role="menu"
        aria-label={`Actions du point ${menu.index + 1}`}
      >
        <div className="map-context-coords">
          Point {menu.index + 1} / {count}
          {node?.region?.name ? ` — ${node.region.name}` : ''}
        </div>
        <button type="button" role="menuitem" onClick={() => run(onConnect, menu.index)}>
          🔗 Relier à un autre point
        </button>
        <button type="button" role="menuitem" onClick={() => run(onFork, menu.index)}>
          🌿 Démarrer une branche ici
        </button>
        <button type="button" role="menuitem" onClick={() => run(onDelete, menu.index)}>
          🗑️ Supprimer ce point
        </button>
      </div>
    </>
  )
}

export default InfraNodeMenu
